// extracted by mini-css-extract-plugin
module.exports = {"buttonInline":"_2htZT02"};